import styled from '@emotion/styled';
import { colorConstants } from 'config/colorConstants';

export const StyledAppliedFiltersSection = styled.div`
    position: relative;
    width: 100%;
    z-index: 20;
`;

export const StyledAppliedFiltersDetailOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 21;
`;

export const StyledAppliedFiltersBar = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    min-height: 38px;
    padding: 8px 16px;
    border-radius: 4px;
    background: ${colorConstants.greyAlt9};

    &.is-clickable {
        cursor: pointer;
    }

    .applied-filters-label {
        flex-shrink: 0;
        font-size: 12px;
        line-height: 22px;
        font-weight: 400;
        color: ${colorConstants.axisLabelGrey};
        white-space: nowrap;
    }

    .applied-filters-items {
        display: flex;
        min-width: 0;
        flex: 1;
        align-items: center;
        gap: 4px;
        overflow: hidden;
        white-space: nowrap;
    }

    .applied-filters-item {
        flex-shrink: 0;
        font-size: 12px;
        line-height: 20px;
        font-weight: 500;
        color: ${colorConstants.axisLabelGrey};
    }

    .applied-filters-divider.ant-divider-vertical {
        top: 0;
        height: 14px;
        margin: 0 8px;
        border-inline-start-color: ${colorConstants.greyAlt6};
    }
`;
